import React, { Fragment, useEffect, useRef, useState } from 'react';

import CommonImage from '@components/CommonImage';

import SelectColor from '@features/assets/components/CommonComponents/SelectColor';

import { materialColortabs } from '@utils/MaterialsUtil';
import { generateRandomString } from '@utils/Util';

const MaterialColorWrapper = ({
	renderFrom = '',
	colorSections,
	setColorSections,
	handleTabChange,
	handleColorGroupIdList,
	isMultiSelection = false
}) => {
	const [showColorPopup, setShowColorPopup] = useState(false);
	const colorDropdownRef = useRef();

	const onOutSideClick = (e) => {
		let selectedElement = e.target;
		if (colorDropdownRef.current && !colorDropdownRef.current.contains(selectedElement)) {
			setShowColorPopup(false);
		}
	};

	useEffect(() => {
		document.addEventListener('click', onOutSideClick, { capture: true });
		return () => {
			document.removeEventListener('click', onOutSideClick, { capture: true });
		};
	}, []);

	const renderSelectedColors = () => {
		const getSelectedColors = (type) => {
			let selectedColors = [];
			colorSections.forEach((color) => {
				selectedColors = [...selectedColors, ...color[type]];
			});
			return selectedColors;
		};
		let selectedPantoneColors = getSelectedColors('selectedPantoneColorList');
		let selectedGroupColors = getSelectedColors('selectedGroupColorList');
		const selectedColors = selectedGroupColors.length > 0 ? selectedGroupColors : selectedPantoneColors;

		return selectedColors?.map((item) => (
			<li className="d-flex justify-content-start align-items-center" key={`key_${item?.id}`}>
				<span
					className="color-icon mr-1"
					style={{
						background: item?.hexCode
					}}
				/>
				<span className="code gray_dark_02 regular-14">{item?.code || item?.name}</span>
			</li>
		));
	};

	const isTCXColorDisabled = (item) => {
		return item?.selectedGroupColorList?.some((color) => color.isTransparent === true);
	};

	const addColorSection = () => {
		setColorSections((prev) => [
			...prev,
			{
				id: generateRandomString(),
				selectedGroupColorList: [],
				selectedPantoneColorList: [],
				pantoneColorIds: [],
				colorGroupIdList: [],
				colorType: 'SOLID',
				isMultiSelect: false
			}
		]);
	};

	const removeColorSection = (id) => {
		setColorSections((prev) => prev.filter((section) => section.id !== id));
	};

	return (
		<div className="material-color-add-v2" ref={renderFrom !== 'DESIGN' ? colorDropdownRef : null}>
			<div className="select-component color-select-dropdown chip-component mb-3">
				<label htmlFor="collection">Color</label>
				<div
					className="click-box text-right click mb-1"
					onClick={() => setShowColorPopup((prev) => !prev)}
				>
					<div className="all-color-code">
						<ul className="d-flex gap-1 flex-wrap">{renderSelectedColors()}</ul>
					</div>
				</div>

				<div
					className={`material-color-dropdown-wrapper scroll-y-label ${showColorPopup ? 'show' : ''}`}
				>
					<div className="d-flex justify-content-between">
						<label htmlFor="colorSelect" className="text-left mb-1">
							Select Color
						</label>
						<div>
							<CommonImage
								src={'/icons/close.svg'}
								alt={'add'}
								onClick={() => setShowColorPopup(false)}
								className={'cursor-pointer'}
							/>
						</div>
					</div>
					{colorSections?.map((section) => (
						<Fragment key={section.id}>
							<div className="color-type-tab inner-tabs my-3 d-flex align-items-center justify-content-between">
								<div>
									<ul>
										{Object.entries(materialColortabs).map(([key, name]) => (
											<li
												key={key}
												className={key === section.colorType ? 'active' : ''}
												onClick={() => handleTabChange(key, section)}
											>
												{name}
											</li>
										))}
									</ul>
								</div>
								{colorSections?.length > 1 && (
									<div className="action-icon">
										<CommonImage
											src={'/icons/trash.svg'}
											alt={'add'}
											width={20}
											height={20}
											className={'cursor-pointer'}
											onClick={() => removeColorSection(section.id)}
										/>
									</div>
								)}
							</div>
							<div className="mb-2">
								<SelectColor
									selectedColorList={section.selectedGroupColorList}
									setSelectedColorList={(items) =>
										handleColorGroupIdList(items, section.id, 'selectedGroupColorList')
									}
									setPantoneColorIds={(items) =>
										handleColorGroupIdList(items, section.id, 'colorGroupIdList')
									}
									isShowLabel={false}
									isMultiple={section.isMultiSelect}
									placeholder={'Select main color'}
									colorType={'group'}
									selectedColorType={section.colorType}
								/>
							</div>
							<div>
								<SelectColor
									selectedColorList={section.selectedPantoneColorList}
									setSelectedColorList={(items) =>
										handleColorGroupIdList(items, section.id, 'selectedPantoneColorList')
									}
									setPantoneColorIds={(items) =>
										handleColorGroupIdList(items, section.id, 'pantoneColorIds')
									}
									isShowLabel={false}
									isMultiple={section.isMultiSelect}
									placeholder={'Select TCX color'}
									colorType={'pantone'}
									isDisabled={isTCXColorDisabled(section)}
								/>
							</div>
						</Fragment>
					))}

					{isMultiSelection && (
						<button className="button outline size32 mt-1" onClick={addColorSection}>
							<CommonImage src={'/icons/plus-20.svg'} width={16} height={16} />
							Add Color Section
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default MaterialColorWrapper;
